export default __webpack_public_path__ + "static/icon-0029c19f5d303f48e016b1eac6caa59b.png";